import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMedal, faUserGraduate, faTrophy } from '@fortawesome/free-solid-svg-icons';
import BadgeShelf from '../Competitions/BadgeShelf';
import WallOfFame from './WallOfFame';
import Nominate from './Nominate';
import './BadgesPage.css';

/* /student/badges: my badges & medals + the Wall of fame (one page).
   /teacher/badges: 3 tabs, so teachers don't mix up their own badges with the ones they give students:
     My badges · Give badges to students · Wall of fame   ("?tab=give" / "?tab=wall" opens one directly) */
const TEACHER_TABS = [
  ['mine', 'My badges', faMedal],
  ['give', 'Give badges to students', faUserGraduate],
  ['wall', 'Wall of fame', faTrophy],
];

const HEAD = {
  mine: {
    title: 'My badges & medals',
    text: 'Your own badges: earned with your students in the challenges, and given by RoboMind for great teaching. Grey ones are still waiting for you! Your best ones also show on your home page card.',
  },
  give: {
    title: 'Give badges to students',
    text: 'Nominate your students for a badge. RoboMind checks it, and they see it on their dashboard and on the wall.',
  },
  wall: {
    title: 'Wall of fame',
    text: 'Everyone who earned a badge or a medal this month and last month, students and teachers.',
  },
};

const tabFromUrl = () => {
  try {
    const t = new URLSearchParams(window.location.search).get('tab');
    return TEACHER_TABS.some(([k]) => k === t) ? t : 'mine';
  } catch {
    return 'mine';
  }
};

const TeacherBadgesPage = () => {
  const [tab, setTab] = useState(tabFromUrl);
  const open = (key) => {
    setTab(key);
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('tab', key);
      window.history.replaceState(null, '', url);
    } catch {
      /* old browsers: the tab still opens */
    }
  };
  const head = HEAD[tab];

  return (
    <div className="rmbp">
      <header className="rmbp-head">
        <span className="rmbp-eyebrow">
          <FontAwesomeIcon icon={faMedal} /> Badges
        </span>
        <h1>{head.title}</h1>
        <p>{head.text}</p>
      </header>

      <div className="rmbp-tabs" role="tablist" aria-label="Badges">
        {TEACHER_TABS.map(([key, label, icon]) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={tab === key}
            className={`rmbp-tab ${tab === key ? 'is-on' : ''}`}
            onClick={() => open(key)}
          >
            <FontAwesomeIcon icon={icon} /> {label}
          </button>
        ))}
      </div>

      {tab === 'mine' && <BadgeShelf path="/api/teacher/competitions/badges" title="My collection" />}
      {tab === 'give' && <Nominate />}
      {tab === 'wall' && (
        <WallOfFame
          path="/api/teacher/awards/feed"
          empty="No badges yet this month. Badges you and your students earn show here for everyone to see."
        />
      )}
    </div>
  );
};

const BadgesPage = ({ mode = 'student' }) => {
  if (mode === 'teacher') return <TeacherBadgesPage />;
  return (
    <div className="rmbp">
      <header className="rmbp-head">
        <span className="rmbp-eyebrow">
          <FontAwesomeIcon icon={faMedal} /> Badges & medals
        </span>
        <h1>My badges & medals</h1>
        <p>
          Earned in the challenges and given by RoboMind for being on time, working hard and making great projects. Grey ones are
          still waiting for you!
        </p>
      </header>

      <div className="rmbp-grid">
        <BadgeShelf path={`/api/${mode}/competitions/badges`} title="My collection" />
        <WallOfFame path={`/api/${mode}/awards/feed`} />
      </div>
    </div>
  );
};

export default BadgesPage;
